import * as actionTypes from "./actionTypes";
const initialState = {
  allData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_ENTERTAINMENT_PRODUCTS:
      return {
        ...state,
        allData: action?.payload?.data || [],
      };
    default:
      return state;
  }
};

export default reducer;

